// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import { store } from './store'

Vue.config.productionTip = false

// eslint-disable-next-line
var vueApp = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})

if ('serviceWorker' in navigator) {
  // Use the window load event to keep the page load performant
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
  })
} else {
  console.log('no sw support, boo !! ')
}



// WEBPACK FOOTER //
// ./src/main.js